import ResearcherDashboard from './ResearcherDashboard' ; 

export default ResearcherDashboard; //